import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';
import { Link } from 'site-modules/shared/components/link/link';
import { scrollToTop } from 'site-modules/personalized-search/utils/scroll-to-top';
import { INVENTORY_SCROLL_TO_TOP_ANCHOR } from 'site-modules/personalized-search/constants/inventory';
import { PersonalizedSearchEntities } from 'site-modules/personalized-search/constants/entities';

import './dealership-item.scss';

export function DealershipItem({
  onUpdateFilters,
  componentParams,
  selectedFilters = null,
  onRendered = noop,
  initialFilters = {},
}) {
  const { details, name, url } = componentParams;
  const { address, reviews, distance_fmt: distanceFmt, location_id: rooftopId } = details;
  const { street, city, state_code: stateCode, zip_code: zip } = address;
  const rating = reviews.count ? reviews.simple : undefined;
  const selectedRooftopId = selectedFilters?.rooftopId;

  const handleInventoryClick = useCallback(
    e => {
      e.preventDefault();
      scrollToTop(INVENTORY_SCROLL_TO_TOP_ANCHOR);

      if (selectedRooftopId?.includes(rooftopId)) return;

      setTimeout(() => {
        onUpdateFilters({ ...initialFilters, rooftopId: [rooftopId] });
      });
    },
    [onUpdateFilters, rooftopId, initialFilters, selectedRooftopId]
  );

  useEffect(() => {
    onRendered();
  }, [onRendered]);

  return (
    <div className="dealership-card rounded-16 p-1 mb-1 d-flex justify-content-between">
      <div>
        <h3 className="size-16 fw-bold text-cool-gray-10">{name}</h3>
        {!!rating && <RatingStars rating={rating} className="text-primary-darker me-0_25" />}
        <div className="size-14 text-cool-gray-40 mb-0_5">
          <span className="me-0_25">{distanceFmt} away</span>|
          <span className="ms-0_25">
            {street}, {city}, {stateCode}&nbsp;{zip}
          </span>
        </div>
        <div className="d-flex">
          <Link
            to={`#${INVENTORY_SCROLL_TO_TOP_ANCHOR}`}
            className="me-1 px-0 py-0 fw-normal text-underline size-16 text-cool-gray-30"
            onClick={handleInventoryClick}
          >
            <span className="text-underline size-16">Inventory</span>
          </Link>
          <span className="text-cool-gray-60">|</span>
          <Link
            to={url}
            className="ms-1 text-underline"
            data-tracking-id="view_dealer_details"
            data-tracking-value={name}
          >
            Dealer profile
          </Link>
        </div>
      </div>
      <div className="icon-wrapper col-auto rounded-8 ms-1 bg-cool-gray-80 d-flex justify-content-center align-items-center text-cool-gray-40">
        <i className="icon-office size-20" aria-hidden />
      </div>
    </div>
  );
}

DealershipItem.propTypes = {
  onUpdateFilters: PropTypes.func.isRequired,
  componentParams: PersonalizedSearchEntities.dealership.isRequired,
  selectedFilters: PropTypes.shape({}),
  onRendered: PropTypes.func,
  initialFilters: PropTypes.shape({}),
};
